import { FormControl, Stack, Spinner, RadioGroup, Radio, FormErrorMessage, Box, Text } from '@chakra-ui/react'
import { useFormContext, Controller } from 'react-hook-form'

import { FormLabel } from '../../components/FormLabel'
import { RadioStack } from '../../components/RadioStack'

import { SelectionType } from 'brokertslib/src/enums'
import { useSelections } from '../../hooks'
import { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos/Travel'

export const TripSportType = ({ isContracted }: { isContracted: boolean }) => {
  const { control, formState: { errors } } = useFormContext<InsuranceParamsTravelDto>()

  const { data: dataSportType, isLoading: isLoadingSportType, isFetching: isFetchingSportType } = useSelections(SelectionType.TravelSportType)

  return (
    <FormControl isInvalid={!!errors.travel?.sportType} isRequired>
      <Stack direction={'row'}>
        <FormLabel
          tooltip={
            <Box>
              <strong>REKREAČNÍ SPORTY</strong>
              <Text>Běžné individuální nebo kolektivní sporty, např. atletika, badminton, basketbal, cyklistika, fotbal, sjíždění klidné vody (tj. stojatá nebo proudící voda bez peřejí) a sjíždění divoké vody do I. stupně obtížnosti, tenis, turistika v terénech do 3 500m n. m. včetně, vodní a plážové atrakce.</Text><br />
              <strong>ZIMNÍ SPORTY</strong>
              <Text>Např. lední hokej, lyžování a snowboarding na vyznačených a veřejnosti přístupných sjezdovkách a trasách včetně přístupových cest k nim.</Text><br />
              <strong>RIZIKOVÉ SPORTY</strong>
              <Text>Např. bojové sporty, box, cyklokros, jízda na vodním skútru, judo, karate, potápění s použitím samostatných dýchacích přístrojů do hloubky 40 m včetně, rafting nebo jiné sjíždění divoké vody od II. do III. stupně obtížnosti, surfing, vysokohorská turistika v terénech nad 3 500 m n. m..</Text><br />
              <strong>ORGANIZOVANÉ SPORTY</strong>
              <Text>Závody, soutěže pořádané na amatérské úrovni, vč. přípravy na ně. U DIRECT pojišťovny, a.s. a Kooperativa pojišťovny, a.s., VIG se vztahuje i na profesionální sporty.</Text>
            </Box>
          }
        >
          Provozované sporty během cesty
        </FormLabel>
        {(isFetchingSportType || isLoadingSportType) && <Spinner />}
      </Stack>
      <Controller
        name="travel.sportType"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
            <RadioStack variant="stackedTile">
              {dataSportType?.data.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  {item.description}
                </Radio>
              ))}
            </RadioStack>
          </RadioGroup>
        )}
      />
      {errors.travel?.sportType && <FormErrorMessage>{errors.travel.sportType.message}</FormErrorMessage>}
    </FormControl>
  )
}
